//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

//Components
import LoanApplicationList from "./LoanApplicationList";

//Custom UI Components
import LoadingModal from "../CustomUIComponents/LoadingModal/LoadingModal";
import UserNotification from "../CustomUIComponents/UserNotification/UserNotification";

//Constants
import {
  API_RESPONSE_STATUS_CODES,
  DASHBOARD_FILTER,
  DEFAULT_USER_SELECTION,
  SEARCH_FILTER_PAGES,
} from "../Utils/Constants";

//Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

//Actions
import {
  getLoanApplicationsOnLoanPortfolioAction,
  getClientInfoByIdAction,
  clearLoanApplicationDetailsAction,
  saveLoanApplicationId,
  getLoanApplicationByIdAction,
  downloadLiveData,
  generateAuditAction,
} from "./LoanApplicationListAction";
import { setSearchFilterAction } from "../redux/Action";

//Strings
import { Strings } from "../Translations/i18n";

class LoanApplicationListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: "",
      notificationSuccess: false,
      notificationFailure: false,
      loanApplicationsData: [],
      showConfirmationDialog: false,
      selectedApplicationForSelfAssignment: {},
      showLoadingModal: false,
      loanApplicationsProfilePic: [],
      showUserInputModal: false,
      error: "",
      users: [
        {
          name: "Usuario",
          value: DEFAULT_USER_SELECTION,
        },
      ],
      searchFilter: {},
      dropdownData: [],
    };
    this.isCardClick = false;
  }

  componentDidMount() {
    if (this.props.loginReducer.authority !== "CASHIER") {
      this.setState({
        showLoadingModal: true,
      });
      this.loanPortfolioSearchFilter({
        filter: {
          disbursementFromDate: this.props.searchFilter.dfd,
          disbursementToDate: this.props.searchFilter.dtd,
          filterCategory: this.props.searchFilter.fc,
          searchLoanID: this.props.searchFilter.lid,
          offset: this.props.searchFilter.oft,
          limit: this.props.searchFilter.lmt,
          provincia: this.props.searchFilter.pro,
        },
        search: {},
      });
    }
  }

  componentWillUnmount() {
    if (!this.isCardClick) {
      this.props.setSearchFilterAction(
        SEARCH_FILTER_PAGES.DASHBOARD,
        DASHBOARD_FILTER
      );
    }
  }

  clearLoanApplicationList = () => {
    this.setState({
      loanApplicationsData: [],
    });
  };
  handleOnClickResetFilterSearch = () => {
    this.loanPortfolioSearchFilter({});
  };
  handleUserModalOpenClick = () => {
    this.setState({
      notificationFailure: false,
      showUserInputModal: true,
      error: "",
    });
  };

  handleUserModalCloseClick = () => {
    this.setState({
      showUserInputModal: false,
      error: "",
    });
  };

  showNotification = () => {
    if (this.state.error) {
      return (
        <UserNotification
          userNotificationObj={{
            message: this.state.error,
            level: "error",
            title: "Error !",
          }}
        />
      );
    }
  };

  /**
   * This function will get called when cashier clicks on loan application card and will redirect cashier to loan application
   */
  handleOnClickLoanApplicationCard = (applicationId) => {
    this.setState({ showLoadingModal: true });
    //Store search filter in reducer
    this.isCardClick = true;
    this.props.setSearchFilterAction(
      SEARCH_FILTER_PAGES.DASHBOARD,
      this.state.searchFilter,
      SEARCH_FILTER_PAGES.DASHBOARD
    );

    this.props.clearLoanApplicationDetailsAction();
    this.props.saveLoanApplicationId(applicationId);
    this.props.getLoanApplicationByIdAction(applicationId, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({ loanInfo: responseData.data }, () => {
          this.props.history.push(APPLICATION_CONFIGURATIONS.path.loanDetails);
        });
      }
      let error = "";
      if (responseData.status !== API_RESPONSE_STATUS_CODES.SUCCESS) {
        error = Strings("errorGetLoanApplicationById");
      }
      this.setState({
        showLoadingModal: false,
        error: error,
      });
    });
  };

  /**
   * This function will get called when analyst clicks on assign option of application card
   */
  handleOnClickLoanApplicationAssign = (applicationData) => {
    this.setState({
      showConfirmationDialog: true,
      selectedApplicationForSelfAssignment: applicationData,
    });
  };

  /**
   * This function will be called when cashier clicks on create new application
   */
  handleOnClickcreateNewApplication = () => {
    this.props.history.push(
      APPLICATION_CONFIGURATIONS.path.createLoanApplication
    );
  };

  loanPortfolioSearchFilter = (filterSearchObject) => {
    this.setState({
      showLoadingModal: true,
      searchFilter: {
        dfd: filterSearchObject.disbursementFromDate,
        dtd: filterSearchObject.disbursementToDate,
        fc: filterSearchObject.filterCategory,
        lid: filterSearchObject.searchLoanID,
        oft: filterSearchObject.offset,
        lmt: filterSearchObject.limit,
        pro: filterSearchObject.provincia,
      },
    });
    //call search API
    getLoanApplicationsOnLoanPortfolioAction(
      filterSearchObject,
      (responseData) => {
        if (responseData?.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
          //parse data
          this.setState({
            notificationFailure: false,
            loanApplicationsData: responseData.data.loans,
            numberOfPages: responseData.data.numberOfPages,
            showLoadingModal: false,
          });
        } else {
          this.setState({
            errorMessage: Strings("errorSomethingWentWrong"),
            notificationFailure: true,
            showLoadingModal: false,
          });
        }
      }
    );
  };

  handleDownloadLiveData = (searchFilterObject) => {
    delete searchFilterObject.limit;
    delete searchFilterObject.offset;
    let errorMessage = "";
    this.setState({
      notificationSuccess: false,
      notificationFailure: false,
      successMessage: "",
      level: "",
      showLoadingModal: true,
    });
    if (
      searchFilterObject.filter.disbursementFromDate === undefined ||
      searchFilterObject.filter.disbursementToDate === undefined
    ) {
      errorMessage = Strings("dateRangeErrorForLiveData");
      this.setState({
        notificationFailure: true,
        notificationSuccess: false,
        errorMessage,
        level: "error",
        showLoadingModal: false,
      });
    }

    errorMessage === "" &&
      downloadLiveData(searchFilterObject, (responseData) => {
        if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
          this.setState({
            notificationSuccess: true,
            notificationFailure: false,
            successMessage: Strings("liveDataSuccessRequest"),
            level: "success",
            showLoadingModal: false,
          });
        } else {
          this.setState({
            notificationFailure: true,
            notificationSuccess: false,
            errorMessage: Strings(responseData.error.message),
            level: "error",
            showLoadingModal: false,
          });
        }
      });
  };

  generateAudit = (id) => {
    this.setState({ showLoadingModal: true });
    generateAuditAction(id, (responseData) => {
      if (responseData.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          notificationFailure: false,
          showLoadingModal: false,
        });
      } else {
        this.setState({
          errorMessage: Strings("errorSomethingWentWrong"),
          notificationFailure: true,
          showLoadingModal: false,
        });
      }
    });
  };

  render() {
    return (
      <div>
        <LoadingModal showLoadingModal={this.state.showLoadingModal} />
        {this.state.notificationFailure && (
          <UserNotification
            userNotificationObj={{
              message: this.state.errorMessage,
              level: "error",
              title: "Error !",
            }}
          />
        )}
        {this.state.notificationSuccess && (
          <UserNotification
            userNotificationObj={{
              message: this.state.successMessage,
              level: "success",
              title: "Success !",
            }}
          />
        )}
        {this.showNotification()}

        <LoanApplicationList
          loanApplicationsList={this.state.loanApplicationsData}
          handleOnClickLoanApplicationCard={
            this.handleOnClickLoanApplicationCard
          }
          handleOnClickcreateNewApplication={
            this.handleOnClickcreateNewApplication
          }
          handleOnClickFilterSearch={this.loanPortfolioSearchFilter}
          userRole={this.props.loginReducer.authority}
          handleOnClickLoanApplicationAssign={
            this.handleOnClickLoanApplicationAssign
          }
          handleOnClickResetFilterSearch={this.handleOnClickResetFilterSearch}
          loanApplicationsListProfilePics={
            this.state.loanApplicationsProfilePic
          }
          handleUserModalOpenClick={this.handleUserModalOpenClick}
          handleUserModalCloseClick={this.handleUserModalCloseClick}
          showUserInputModal={this.state.showUserInputModal}
          clearLoanApplicationListData={this.clearLoanApplicationList}
          getLoanApplicationId={this.getLoanApplicationId}
          loginReducer={this.props.loginReducer}
          users={this.state.users}
          numberOfPages={this.state.numberOfPages}
          LOAN_PORTFOLIO={this.props.LOAN_PORTFOLIO}
          searchFilter={this.props.searchFilter}
          handleDownloadLiveData={this.handleDownloadLiveData}
          dropdownData={this.state.dropdownData}
          getDropdownDataFromContainer={this.state.dropdownData}
          generateAudit={this.generateAudit}
        />
      </div>
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      saveLoanApplicationId: saveLoanApplicationId,
      getClientInfoByIdAction: getClientInfoByIdAction,
      getLoanApplicationByIdAction: getLoanApplicationByIdAction,
      getLoanApplicationsOnLoanPortfolioAction:
        getLoanApplicationsOnLoanPortfolioAction,
      clearLoanApplicationDetailsAction: clearLoanApplicationDetailsAction,
      setSearchFilterAction: setSearchFilterAction,
      downloadLiveData: downloadLiveData,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
    searchFilter: state.searchFilterReducer.dashboardSearchFilter,
  };
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(LoanApplicationListContainer)
);
